import { cva } from "class-variance-authority";

export const headingVariants = cva(
  "font-medium tracking-normal text-neutral-700",
  {
    variants: {
      size: {
        displayXL:
          "text-[42px] leading-[50px] md:text-[64px] md:leading-[80px]",

        displayLG:
          "text-[32px] leading-[42px] md:text-[40px] md:leading-[50px]",

        headingLG:
          "text-[24px] leading-[32px] md:text-[32px] md:leading-[40px]",

        headingMD:
          "text-[20px] leading-[30px] md:text-[24px] md:leading-[38px]",
      },
    },

    defaultVariants: {
      size: "headingMD",
    },
  }
);

export const textVariants = cva(
  "tracking-normal text-neutral-700",
  {
    variants: {
      size: {
        bodyLG:
          "text-[16px] leading-[24px] md:text-[20px] md:leading-[30px]",

        bodyMD:
          "text-[14px] leading-[20px] md:text-[18px] md:leading-[30px] font-medium",

        bodySM:
          "text-[14px] leading-[20px] md:text-[16px] md:leading-[24px]",

        bodySMMedium:
          "text-[14px] leading-[20px] md:text-[16px] md:leading-[24px] font-medium",

        labelLG:
          "text-[14px] leading-[20px] font-medium",

        labelMD:
          "text-[14px] leading-[20px]",

        labelSM:
          "text-[9px] leading-[14px] md:text-[11px] md:leading-[16px]",

        titleLG:
          "text-[24px] leading-[32px] font-medium md:text-[40px] md:leading-[50px]",

        titleMD:
          "text-[24px] leading-[32px] font-medium md:text-[32px] md:leading-[40px]",

        navLG:
          "text-[18px] leading-[30px] font-medium",
      },
    },

    defaultVariants: {
      size: "bodyMD",
    },
  }
);